module.exports = __webpack_public_path__ + "img/32_11.5debfa8e.png";